import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {Dictionary} from "../../../elements/dictionary";
import {NavModel} from "./navModel";
import {resolve} from "../../../../container";
import {ConditionalUnLitElement} from "../../../../common/elements";
import {trackingNavigationInteract} from "../../../../tracking/trackingAttributes";

@customElement("eop-navigation-search-link")
export class EopNavigationSearchLink extends ConditionalUnLitElement {

    @property({attribute: "without-label", type: Boolean})
    public withoutLabel: boolean = false;

    private searchHref?: string;
    private dictionary: Dictionary;

    public constructor(private navModel: NavModel = resolve(NavModel)) {
        super();
        this.searchHref = this.navModel.getActiveSector()?.searchHref || this.navModel.getSearchHref();
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.dictionary = Dictionary.of(this);
    }

    protected renderTemplate(): TemplateResult {
        const searchLabel = this.dictionary.translate("MSG_HEADER_SEARCH_SUBMIT_BUTTON_LABEL");
        return html`
            <a href=${this.searchHref}
               title=${searchLabel}
               class="search-link"
               ${trackingNavigationInteract("header-search-button", this.searchHref)}
            >
                <span class="search-link-text${this.withoutLabel ? " without-label" : ""}">${this.withoutLabel ? "" : searchLabel}</span>
            </a>
        `;
    }

    protected shouldRender(): boolean {
        return !!this.searchHref;
    }
}